import { createContext, useContext, useEffect, useState } from "react";
import { useTutor } from "./AiTutorContext";
import {
  getConvrseScore,
  getGpMedia,
  handledescriptiveAnswer,
  practiceConvo,
} from "../network/TutorApiService";
import useStateRef from "react-usestateref";
import {
  BOTTOM_BUTTONS,
  classifierInitialState,
  ERROR_MESAGES,
  generateNewChatId,
  handleExtractAnswerImages,
  handleExtractQuestionImages,
  HTTP_CODES,
  LOADING_MESSAGE,
} from "../utils/TutorConstants";
import { useCustomToast } from "../components/molecules/ai-tutor/useCustomToast";
import {
  checkRules,
  getUserSelectedAnswer,
  isEmptyObject,
  isEmptyOrNull,
  isNotEmptyOrNull,
} from "../utils/common-utils";
import { useRoot } from "./RootContext";
import {
  callSelfLearn,
  createGuidedPractice,
  endTask,
  learnApiService,
  sendVideoEvents,
  updateChatIdInLpProgress,
} from "../network/LearnApiService";
import { matchFibAnswers } from "../utils/Helper";
import { startTask } from "../api/task-services";
import { useLocation, useNavigate } from "@remix-run/react";
import { StorageService } from "../utils/StorageUtils";
import {
  learningModes,
  questionTypes,
  taskTypes,
} from "../utils/LearningPathUtils";
import { useAudio } from "./AudioContext";
import { sendCustomEvent, sendScopedException } from "../utils/sentry";
import { getTaskType } from "../utils/accordion/accordionHelper";

const PracticeContext = createContext();
export const PracticeProvider = ({ children }) => {
  const { state: routeState = {} } = useLocation();
  const {
    setUserQuery,
    setIsCompleted,
    isCompleted,
    setGrade,
    setSubject,
    setTopic,
    setLoader,
    setClassifierInfo,
    userQuery,
    loader,
    curriculumObj,
    selectedSubTopic,
    setSelectedSubTopic,
    selectedTopic,
    setSelectedTopic,
    overAllQuestionResult,
    setOverAllQuestionResult,
    journeyId,
    setJourneyId,
    setIsTaskCompleted,
    setTaskStatus,
    topicMasterUuid,
    topic,
    subTopic,
    setIsFeedbackSubmitted,
    isChapterEndAssessment,
    chapterEndAssessmentType,
    selectedExperiential,
    isExperientialFromWall,
    setIsExperientialFromWall,
    setTaskStepId,
    taskStepId,
    subjectMasterUUid,
    topicId,
    subTopicId,
    subtopicMasterUuid,
    setTaskAnalytics,
    setIsFactual,
    handleSetCurriculumDetails,
    getCurriculumInfo,
    setExperientialLearningData,
    setSelectedFactualIndex,
    loaderText,
    setLoaderText,
    setIsOCREnabled,
  } = useTutor();
  const {
    isStandaloneWithSubjectMapping,
    selectedIndex,
    setSubjectName,
    setSubTopicName,
    subTopicName,
    topicName,
    gpRandom,
    noOfQuestions,
    setTopicName,
    isStandalone,
    taskId,
    setTaskId,
    togglePracDrawer,
    openPracSideMenu,
    setSelectedIndex,
    isRedirectObjectInserted,
    taskType,
    setTaskType,
    isPlayground,
    setIsDiscussFlow,
    isDiscussFlow,
    autoPlay,
    isReviewScreen,
  } = useRoot();
  const navigate = useNavigate();
  const { handlePlayPause, handleResetAudio } = useAudio();
  const showToast = useCustomToast();
  const [userId, setUserId] = useState("");
  const [taskCategory, setTaskCategory] = useState(null);
  const [chatHistory, setChatHistory, chatHistoryRef] = useStateRef({});
  const [chatQuery, setChatQuery, chatQueryRef] = useStateRef("");
  const [streamingText, setStreamingText, streamingTextRef] = useStateRef("");
  const [chatId, setChatId, chatIdRef] = useStateRef("");
  const [isConvCompleted, setIsConvCompleted, isConvCompletedRef] =
    useStateRef(false);
  const [questions, setQuestions, questionsRef] = useStateRef([]);
  const [displayedQues, setDisplayedQues, displayedQuesRef] = useStateRef([]);
  const [currentQuesIndex, setCurrentQuestionIndex, currentQuesIndexRef] =
    useStateRef(-1);
  const [isDescSubmitted, setIsDescSubmitted, isDescSubmittedRef] =
    useStateRef(false);
  const [isCorrect, setIsCorrect, isCorrectRef] = useStateRef(false);
  const [isLastQues, setIsLastQues, isLastQuesRef] = useStateRef(false);
  const [selectedJourney, setSelectedJourney, selectedJourneyRef] =
    useStateRef();
  const [chatIndex, setChatIndex, chatIndexRef] = useStateRef(0);
  const [learningStepData, setLearningStepData, learningStepDataRef] =
    useStateRef({});
  const [showHintBtn, setShowHintBtn, showHintBtnRef] = useStateRef(false);
  const [questionStartTime, setQuestionStartTime, questionStartTimeRef] =
    useStateRef();
  const [questionEndTime, setQuestionEndTime, questionEndTimeRef] =
    useStateRef();
  const [
    showNextBtnForFactual,
    setShowNextBtnForFactual,
    showNextBtnForFactualRef,
  ] = useStateRef(false);
  const [
    displayQuestionsWithoutFactualVideo,
    setDisplayQuestionsWithoutFactualVideo,
    displayQuestionsWithoutFactualVideoRef,
  ] = useStateRef(false);
  const [
    clearAllBottomButtons,
    setClearAllBottomButtons,
    clearAllBottomButtonsRef,
  ] = useStateRef(false);
  const [mediaDetails, setMediaDetails, mediaDetailsRef] = useStateRef([]);
  const [isAnswerSubmitted, setIsAnswerSubmitted, isAnswerSubmittedRef] =
    useStateRef(false);
  const [assesmentInfo, setAssesmentInfo] = useState({});
  const [assistantRefImages, setAssistantRefImages] = useState({});
  const [questionID, setQuestionID] = useState("");
  const [isDescAnsQues, setIsDescAnsQues] = useState(false);
  const [isConcluded, setIsConcluded] = useState(false);
  const [descriptiveAnswer, setDescriptiveAnswer] = useState({});
  const [tryCount, setTryCount, tryCountRef] = useStateRef(0);
  const [backUpObject, setBackUpObject, backUpObjectRef] = useStateRef({});
  const [showConcludeBtn, setShowConcludeBtn, showConcludeBtnRef] =
    useStateRef(false);
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [
    isConcludeInProgress,
    setIsConcludeInProgress,
    isConcludeInProgressRef,
  ] = useStateRef(false);
  const [
    isNextQuestionLoading,
    setIsNextQuestionLoading,
    isNextQuestionLoadingRef,
  ] = useStateRef(false);
  useEffect(() => {
    if (isCompleted && streamingText !== "") {
      handleStreamingFlow();
    }
  }, [streamingText, isCompleted]);

  useEffect(() => {
    if (isConvCompleted && displayedQues?.length > 0) {
      handleUpdateisConv();
    }
  }, [isConvCompleted]);

  useEffect(() => {
    const storedBackUp = StorageService.getItem("backUpObject");
    if (isNotEmptyOrNull(storedBackUp)) {
      setBackUpObject(storedBackUp);
    }
  }, []);

  useEffect(() => {
    const value = StorageService.getItem("xUserId");
    const type = StorageService.getItem("taskType");

    if (isRedirectObjectInserted || value) {
      setUserId(value);
      setTaskCategory(isNotEmptyOrNull(type) ? Number(type) : 1);
    }
  }, [isRedirectObjectInserted]);

  useEffect(() => {
    if (
      (selectedIndex == 3 || selectedIndex == 5) &&
      isStandaloneWithSubjectMapping &&
      isNotEmptyOrNull(selectedSubTopic)
    ) {
      generateGuidedPrtcice();
    } else if (
      (selectedIndex === 0 || selectedIndex === 4 || selectedIndex === 5) &&
      isNotEmptyOrNull(selectedSubTopic) &&
      !isReviewScreen
    ) {
      if (isNotEmptyOrNull(selectedSubTopic?.journeyId)) {
        // storing the journey id for back up object
        if (
          selectedSubTopic?.journeyId &&
          !isStandalone &&
          !isRedirectObjectInserted
        ) {
          const updatedBackUp = {
            ...backUpObjectRef.current,
            journeyId: selectedSubTopic?.journeyId,
          };
          setBackUpObject(updatedBackUp);
          StorageService.setItem("backUpObject", updatedBackUp);
        }
        //Adding handwriting enabled check
        if (
          isNotEmptyOrNull(
            selectedSubTopic?.taskAttributes?.handwritingEnabled
          ) &&
          !isStandalone &&
          !isRedirectObjectInserted
        ) {
          const updatedBackUp = {
            ...backUpObjectRef.current,
            isOCR: true,
          };
          setBackUpObject(updatedBackUp);
          StorageService.setItem("backUpObject", updatedBackUp);
          setIsOCREnabled(true);
        }
        setJourneyId(selectedSubTopic?.journeyId);
        createLearningStepCall(selectedSubTopic?.journeyId);
      } else if (
        isNotEmptyOrNull(selectedExperiential) ||
        selectedSubTopic?.isExperiential
      ) {
        createSelfLearn(
          isChapterEndAssessment,
          chapterEndAssessmentType,
          selectedExperiential
        );
      } else {
        if (isNotEmptyOrNull(taskId)) {
          if (
            !isStandalone &&
            !isStandaloneWithSubjectMapping &&
            !isRedirectObjectInserted
          ) {
            const updatedBackUp = {
              ...backUpObjectRef.current,
              taskId: taskId,
            };
            setBackUpObject(updatedBackUp);
            StorageService.setItem("backUpObject", updatedBackUp);
          }
          callStartTask(taskId);
        } else if (isNotEmptyOrNull(selectedSubTopic?._id)) {
          if (
            !isStandalone &&
            !isStandaloneWithSubjectMapping &&
            !isRedirectObjectInserted
          ) {
            const updatedBackUp = {
              ...backUpObjectRef.current,
              taskId: selectedSubTopic?._id,
            };
            setBackUpObject(updatedBackUp);
            StorageService.setItem("backUpObject", updatedBackUp);
          }
          callStartTask(selectedSubTopic?._id);
        } else {
          createSelfLearn(isChapterEndAssessment, chapterEndAssessmentType, {});
        }
      }
    } else if (isExperientialFromWall) {
      createSelfLearn(
        isChapterEndAssessment,
        chapterEndAssessmentType,
        selectedExperiential
      );
      setIsExperientialFromWall(false);
    }
  }, [selectedSubTopic]);

  useEffect(() => {
    if (
      selectedIndex === -1 &&
      isNotEmptyOrNull(backUpObjectRef?.current) &&
      !isNotEmptyOrNull(selectedSubTopic) &&
      !isReviewScreen
    ) {
      if (isNotEmptyOrNull(backUpObjectRef?.current?.journeyId)) {
        // handwriting enabled check
        if (backUpObjectRef?.current?.isOCR) {
          setIsOCREnabled(true);
        }
        setJourneyId(backUpObjectRef?.current?.journeyId);
        createLearningStepCall(backUpObjectRef?.current?.journeyId);
      } else if (isNotEmptyOrNull(backUpObjectRef?.current?.taskId)) {
        callStartTask(backUpObjectRef?.current?.taskId);
      } else {
        createSelfLearn(isChapterEndAssessment, chapterEndAssessmentType, {});
      }
    }
  }, []);

  useEffect(() => {
    handleUpdateUserID();
    if (
      (routeState?.parentRoute == "Assesment" ||
        isNotEmptyOrNull(StorageService.getItem("assesmentInfo"))) &&
      !location?.pathname?.includes("review")
    ) {
      handleAssesmentPracticeFlow();
      handlefetchAssesmentIfo();
    }
  }, [routeState]);

  // Update showConcludeBtn when relevant state changes
  useEffect(() => {
    updateShowConcludeBtn();
  }, [streamingText, loader, isConvCompleted, chatIndex, isCorrect]);

  const updateShowConcludeBtn = () => {
    const chatHistoryAtIndex =
      chatHistoryRef?.current?.[currentQuesIndexRef?.current];
    let assistantMessages = [];

    if (Array.isArray(chatHistoryAtIndex)) {
      assistantMessages = chatHistoryAtIndex.filter(
        (message) => message?.role === "assistant"
      );
    }

    let assistantMessageLength = assistantMessages?.length;
    let shouldShowConcludeBtn =
      !isConcludeInProgress &&
      streamingTextRef?.current?.length == 0 &&
      loader == false &&
      !isConvCompletedRef.current &&
      chatIndexRef.current !== 0;

    if (!isCorrectRef?.current) {
      shouldShowConcludeBtn =
        shouldShowConcludeBtn &&
        assistantMessageLength >=
          parseInt(window?.ENV?.SHOW_CONCLUDE_BUTTON_AFTER || 4) &&
        !isLastQuesRef?.current;
    }

    setShowConcludeBtn(shouldShowConcludeBtn);
  };

  const handleUpdateUserID = () => {
    let value = StorageService.getItem("xUserId");
    if (value) {
      setUserId(value);
    }
  };
  const handleLongAnsStreamFlow = async (userAns, images) => {
    const currentChat = [
      { role: "user", content: userAns, descImageList: images },
      {
        role: "assistant",
        content: " ",
      },
    ];
    let existingHis =
      chatHistoryRef?.current?.[currentQuesIndexRef?.current] || [];
    let updatedHistory = [...existingHis, ...currentChat];
    let history = { ...chatHistoryRef?.current };

    history[currentQuesIndexRef?.current] = updatedHistory;
    setChatHistory(history);
    const version_uuid =
      displayedQuesRef?.current?.[currentQuesIndexRef?.current]?.version_uuid;
    let body = {
      data: {
        user_answer: userAns,
        transcribed_images: images,
        version_uuid,
      },
    };
    if (isPlayground) {
      body["data"]["playground_status"] = 1;
    }
    let response = await handledescriptiveAnswer(body, chatIdRef?.current);
    if (response?.data) {
      setDescriptiveAnswer(response?.data || {});
      if (!isEmptyOrNull(questionID)) {
        setIsConvCompleted(true);
      }
    } else {
      setDescriptiveAnswer({ response });
      showToast({
        description: response?.message,
        status: "error",
        position: "bottom",
      });
    }
  };
  const handleStreamingFlow = async () => {
    const version_uuid =
      displayedQuesRef?.current?.[currentQuesIndexRef?.current]?.version_uuid;
    const currentChat = [
      { role: "user", content: chatQuery, chatID: chatIdRef?.current },
      {
        role: "assistant",
        content: streamingText,
        questionID: version_uuid,
        isCorrect: isCorrectRef?.current,
        ...(isConcluded ? { isConcluded: true } : {}),
        ...(isConcluded || isCorrect ? { showAllRefImages: true } : {}),
        chatID: chatIdRef?.current,
      },
    ];
    let existingHis =
      chatHistoryRef?.current?.[currentQuesIndexRef?.current] || [];
    let updatedHistory = [...existingHis, ...currentChat];
    let history = { ...chatHistoryRef?.current };
    history[currentQuesIndexRef?.current] = updatedHistory;

    const index = updatedHistory?.length / 2;
    if (window?.ENV?.ENABLE_VOICE == "true" && autoPlay) {
      const playingIndex = `${chatIdRef?.current}-${index}`;
      handlePlayPause(
        playingIndex,
        streamingText,
        chatIdRef?.current,
        chatIndexRef?.current,
        isCorrectRef?.current,
        version_uuid
      );
    }
    setChatHistory(history);
    setChatIndex(index);
    setChatQuery("");
    setStreamingText("");
    setIsCompleted(false);
    updateShowConcludeBtn();
    const enableHintBtn =
      index >= parseInt(window?.ENV?.SHOW_HINT_BUTTON_AFTER || 1);
    if (enableHintBtn && isConvCompletedRef?.current == false) {
      if (!isEmptyOrNull(questionID)) {
        setShowHintBtn(true);
      } else if (
        isConvCompletedRef?.current == false &&
        (selectedIndex === 3 ||
          selectedIndex == 4 ||
          taskType === "guidedPractise" ||
          taskType === "learnPrerequisite")
      ) {
        if (
          selectedIndex === 3 || selectedIndex == 4
            ? isNotEmptyOrNull(displayedQues)
            : isNotEmptyOrNull(learningStepData)
        ) {
          setShowHintBtn(true);
        }
      }
    }
  };
  const createSelfLearn = async (
    isChapterEndAssessment,
    chapterEndAssessmentType,
    experiential
  ) => {
    let bodyData = {
      taskType: isExperientialFromWall
        ? "experientialLearning"
        : isNotEmptyOrNull(taskType)
        ? taskType
        : selectedSubTopic?.taskType,
      subjectId: isExperientialFromWall
        ? experiential.subjectId
        : isNotEmptyOrNull(subjectMasterUUid)
        ? subjectMasterUUid
        : isNotEmptyOrNull(selectedTopic?.subject?.subjectMasterUUid)
        ? selectedTopic?.subject?.subjectMasterUUid
        : selectedSubTopic?.taskAttributes?.subjectId,
      topicId: isExperientialFromWall
        ? experiential.topicId
        : isNotEmptyOrNull(topicId)
        ? topicId
        : isNotEmptyOrNull(selectedTopic?.topic?.topicId)
        ? selectedTopic?.topic?.topicId
        : selectedSubTopic?.taskAttributes?.topicId,
      taskAttributes: {
        subtopicId: isExperientialFromWall
          ? experiential.subtopicId
          : isNotEmptyOrNull(subTopicId)
          ? subTopicId
          : // : isNotEmptyOrNull(selectedSubTopic?.subtopicId)
            // ? selectedSubTopic?.subtopicId
            selectedSubTopic?.taskAttributes?.subtopicId,
        subtopicMasterUuid: isNotEmptyOrNull(subtopicMasterUuid)
          ? subtopicMasterUuid
          : // : isNotEmptyOrNull(selectedSubTopic?.subtopicMasterUuid)
            // ? selectedSubTopic?.subtopicMasterUuid
            selectedSubTopic?.taskAttributes?.subtopicMasterUuid,
        topicMasterUuid: isExperientialFromWall
          ? experiential.topicMasterUuid
          : isNotEmptyOrNull(topicMasterUuid)
          ? topicMasterUuid
          : isNotEmptyOrNull(selectedTopic?.topicMasterUuid)
          ? selectedTopic?.topicMasterUuid
          : selectedSubTopic?.taskAttributes?.topicMasterUuid,
        topicName: isExperientialFromWall
          ? experiential.topicName
          : isNotEmptyOrNull(topic)
          ? topic
          : isNotEmptyOrNull(selectedTopic?.topic?.topicInfo?.name)
          ? selectedTopic?.topic?.topicInfo?.name
          : selectedSubTopic?.taskAttributes?.topicName,
        subtopicName: isExperientialFromWall
          ? experiential.subTopicName
          : isNotEmptyOrNull(subTopic)
          ? subTopic
          : // : isNotEmptyOrNull(selectedSubTopic?.subtopicInfo?.name)
            // ? selectedSubTopic?.subtopicInfo?.name
            selectedSubTopic?.taskAttributes?.subtopicName,
        chapterEndAssessment:
          selectedSubTopic?.taskAttributes?.chapterEndAssessment ||
          isChapterEndAssessment,
        proficiencyLevel:
          selectedSubTopic?.taskAttributes?.proficiencyLevel ||
          chapterEndAssessmentType.toLowerCase(),
        experientialLearning: {
          id:
            experiential?.id ||
            selectedSubTopic?.taskAttributes?.experientialLearning?.id,
          title:
            experiential?.title ||
            selectedSubTopic?.taskAttributes?.experientialLearning?.title,
          allowCommentsAndInteractions:
            experiential?.allowCommentsAndInteractions ||
            selectedSubTopic?.taskAttributes?.experientialLearning
              ?.allowCommentsAndInteractions,
        },
        handwritingEnabled:
          selectedSubTopic?.taskAttributes?.handwritingEnabled,
      },
    };
    if (isNotEmptyOrNull(bodyData?.topicId)) {
      if (
        !bodyData.taskAttributes.chapterEndAssessment &&
        !isNotEmptyOrNull(bodyData.taskAttributes.subtopicId) &&
        taskType !== "learnPrerequisite"
      ) {
        console.log(
          "Cannot proceed: Chapter end assessment is false and subtopicId is empty"
        );
        return;
      }
      try {
        const { success, data } = await callSelfLearn(bodyData);
        console.log(data);
        if (success) {
          // setOnItemSelected(false);
          if (
            !isStandalone &&
            !isStandaloneWithSubjectMapping &&
            !isRedirectObjectInserted
          ) {
            const updatedBackUp = {
              ...backUpObjectRef.current,
              taskId: data?.data?._id,
            };
            setBackUpObject(updatedBackUp);
            StorageService.setItem("backUpObject", updatedBackUp);
          }

          setTaskId(data?.data?._id);
          callStartTask(data?.data?._id);
        } else {
          console.log("Failure");
          throw new Error("Failure");
        }
      } catch (error) {
        (error.name = "Self Learn API Failed"), // Custom error name for tracking
          // Add a unique fingerprint to identify different occurrences
          sendScopedException(
            error,
            [
              "self-learn-api-failure",
              bodyData?.topicId,
              new Date().toISOString(),
            ],
            { "api-fails": "self-learn-api" },
            {
              selectedTopic: JSON.stringify(selectedTopic, null, 2),
              subtopic: JSON.stringify(selectedSubTopic, null, 2),
            }
          );
      }
    }
  };

  const handlefetchAssesmentIfo = async () => {
    let data = {};
    try {
      data = await StorageService.getItem("assesmentInfo");
      data = JSON.parse(data);
    } catch (e) {
      console.log(e);
    }
    if (Object.keys(data)?.length > 0) {
      setTaskCategory(undefined);
      setTaskType(taskTypes.assessment);
      // StorageService.removeItem("assesmentInfo");
      const { journeyId, questionObj, userAnswer } = data || {};
      setIsDiscussFlow(true);
      setChatId(generateNewChatId());
      handleSetCurriculumDetails(questionObj?.syllabusMapping?.[0]);
      const selectedAnswer = isNotEmptyOrNull(questionObj?.answers_key)
        ? getUserSelectedAnswer(
            userAnswer?.answerResult?.[0]?.givenAnswer,
            questionObj?.options_layout
          )
        : userAnswer?.answerResult?.[0]?.givenAnswer;
      setIsCorrect(userAnswer?.overAllResult || false);
      setIsAnswerSubmitted(true);
      setCurrentQuestionIndex(0);
      setDisplayedQues([{ ...questionObj, userAnswer, showGreen: undefined }]); // removed showGreen to not to display correct answer selected in assessment discuss flow.
      userAnswer.chatId = chatIdRef?.current;
      setAssesmentInfo({
        journeyId,
        questionId: questionObj?.version_uuid,
        userAnswer,
      });
      handlePracticeConv(selectedAnswer);
    }
  };

  const handleAssesmentPracticeFlow = () => {
    setSelectedJourney("");
    setDisplayedQues([]);
    setClearAllBottomButtons(false);
    setSelectedIndex(4);
    openPracSideMenu && togglePracDrawer();
  };

  const callStartTask = async (id) => {
    // setTaskId(id);
    if (isNotEmptyOrNull(id)) {
      try {
        const { success, data } = await startTask(id);
        if (success) {
          if (
            isNotEmptyOrNull(data?.data?.taskAttributes?.experientialLearning)
          ) {
            setExperientialLearningData(
              data?.data?.taskAttributes?.experientialLearning
            );
          } else {
            // setOnNextItemSelected(false);
            if (
              !isStandalone &&
              !isStandaloneWithSubjectMapping &&
              !isRedirectObjectInserted
            ) {
              const updatedBackUp = {
                ...backUpObjectRef.current,
                journeyId: data?.data?.journeyId,
              };
              setBackUpObject(updatedBackUp);
              StorageService.setItem("backUpObject", updatedBackUp);
            }
            if (
              isNotEmptyOrNull(data?.data?.taskAttributes?.handwritingEnabled)
            ) {
              const updatedBackUp = {
                ...backUpObjectRef.current,
                isOCR: true,
              };
              setBackUpObject(updatedBackUp);
              StorageService.setItem("backUpObject", updatedBackUp);
              setIsOCREnabled(true);
            }
            setJourneyId(data?.data?.journeyId);
            setTaskStepId(data?.data?.stepId);
            createLearningStepCall(data?.data?.journeyId);
          }

          console.log(data);
        } else {
          showToast({
            description: "Failed to start task",
            status: "error",
            position: "top",
          });
          sendCustomEvent(
            "Failed to start task",
            "error",
            {
              taskId: id,
              subtopic: selectedSubTopic,
            },
            [
              "task_start_failed",
              id,
              selectedSubTopic,
              new Date().toISOString(),
            ]
          );

          //sentry id,selected subtopic
          console.log("Failure");
        }
      } catch (error) {
        error.name = "Failed to Start Task"; // Custom error name for tracking

        // Add a unique fingerprint to identify different occurrences
        sendScopedException(
          error,
          ["start-task-api-failure", id, new Date().toISOString()],
          { "api-fails": "start-task-api" },
          {
            id: JSON.stringify(id, null, 2),
            subtopic: JSON.stringify(selectedSubTopic, null, 2),
          }
        );
      }
    } else {
      console.log("Task id is empty");
    }
  };

  const createLearningStepCall = (
    id,
    factual,
    resultObject,
    chatId,
    answerValue
  ) => {
    let answerObject = {};
    if (!isEmptyObject(resultObject)) {
      answerObject = {
        ...resultObject,
        chatId: chatId,
      };
    }
    fetchPracticeQuestions(
      id,
      learningStepData?.step_id ? learningStepData?.step_id : 1,
      factual ? "" : answerObject,
      factual ? 1 : answerValue
    );
  };

  const callFinishStep = async () => {
    let finalTaskId = taskId || backUpObjectRef?.current?.taskId;
    try {
      const { success, data } = await endTask(finalTaskId, "");
      // console.log(data);
      if (isNotEmptyOrNull(data?.analytics)) {
        setTaskAnalytics(data?.analytics);
      }
      if (!isEmptyObject(data)) {
        if (data?.taskStatus === "completed") {
          setIsTaskCompleted(true);
          setTaskStatus(
            isNotUndefinedOrNull(data?.message)
              ? data.message
              : "Looks like " +
                  (subTopicName ? subTopicName : topicName) +
                  " clicked!  Ready for the next challenge?"
          );
        }
      }
    } catch (error) {}
  };

  const generateGuidedPrtcice = async () => {
    let { success, data } = await createGuidedPractice(
      topicMasterUuid || selectedTopic?.id,
      selectedSubTopic?.id || subtopicMasterUuid,
      gpRandom,
      noOfQuestions,
      userId,
      taskCategory
    );
    if (success && data?.journey_id) {
      setJourneyId(data?.journey_id);
      fetchPracticeQuestions(data?.journey_id);
      if (
        data?.handwritingEnabled &&
        (isStandaloneWithSubjectMapping || isRedirectObjectInserted)
      ) {
        setIsOCREnabled(true);
      }
    } else {
      if (data?.status == 500) {
        setSelectedSubTopic("");
        let text = !isEmptyOrNull(data?.error)
          ? data?.error
          : "Sorry... No questions exist for this topic";
        setTimeout(() => {
          setClassifierInfo((prev) => {
            return {
              ...prev,
              classifierText: text,
              classifierHistory: [],
            };
          });
        }, 500);
      }
      setCurrentQuestionIndex(-1);
    }
  };

  const handleExtraAndStoreImages = (quesObj, updatedIndex) => {
    //adding answr images
    const answrImages = handleExtractAnswerImages(quesObj);
    const optionImages = handleExtractQuestionImages(quesObj);
    let existingRefImages = { ...(assistantRefImages || {}) };
    existingRefImages[updatedIndex] = [...answrImages, ...optionImages];
    setAssistantRefImages(existingRefImages);
    //end
    if (
      window?.ENV?.ENABLE_GP_MEDIA == "true" &&
      (taskType == taskTypes.guidedPractice ||
        backUpObjectRef?.current?.taskType == taskTypes.guidedPractice)
    ) {
      const versionUUID = quesObj?.version_uuid;
      if (
        isNotEmptyOrNull(versionUUID) &&
        !isStandalone &&
        !isStandaloneWithSubjectMapping &&
        !isRedirectObjectInserted
      ) {
        const updatedBackUp = {
          ...backUpObjectRef.current,
          question_id: versionUUID,
        };
        setBackUpObject(updatedBackUp);
        StorageService.setItem("backUpObject", updatedBackUp);
      }
      fetchMediaDetails(versionUUID || backUpObjectRef?.current?.question_id);
    }
    const descQuestionTypes = [
      questionTypes.short_answer,
      questionTypes.long_answer,
      questionTypes.very_short_answer,
    ];
    const isDescQues = descQuestionTypes?.includes(quesObj?.question_type);
    setIsDescAnsQues(isDescQues);
    if (isNotEmptyOrNull(quesObj?.userAnswer?.chatId)) {
      setChatIndex((chatHistoryRef.current?.length || 0) / 2);
      setChatId(quesObj?.userAnswer?.chatId);
    } else {
      setChatId(generateNewChatId());
    }
  };

  const fetchPracticeQuestions = async (id, step_id, answer, answerCount) => {
    // Reset states at the start of fetching new questions
    setIsConvCompleted(false);
    setIsCorrect(false);
    setStreamingText("");
    setChatQuery("");

    let script = await checkRules(
      learningStepData,
      learningStepData?.learning_mode?.toLowerCase() ===
        learningModes?.FactualBasket
        ? 1
        : overAllQuestionResult?.overAllResult
        ? 1
        : 0
    );
    if (isNotEmptyOrNull(script)) {
      let scriptData = {
        exitScript: true,
        text: script,
      };
      let ques = [...displayedQuesRef?.current];
      ques.push(scriptData);
      setCurrentQuestionIndex(currentQuesIndexRef?.current + 1);
      setDisplayedQues(ques);
      setShowNextBtnForFactual(false);
    }

    setIsFactual(false);
    let curIndex = currentQuesIndexRef?.current;
    let user_answer;
    let count;
    if (curIndex != -1) {
      user_answer = { ...overAllQuestionResult, chatId: chatIdRef?.current };
      count = user_answer?.overAllResult == true ? 1 : 0;
    }

    if (isNotEmptyOrNull(StorageService.getItem("videoEvents"))) {
      let videoEventsData = JSON.parse(StorageService.getItem("videoEvents"));
      await sendVideoEvents(videoEventsData?.journey_type, videoEventsData);
      StorageService.removeItem("videoEvents");
    }

    const { success, data } = await learnApiService(
      id ?? journeyId,
      step_id ??
        (taskType == taskTypes.guidedPractice ? "guidedPractice" : taskType),
      displayedQues[currentQuesIndex]?.userAnswer ?? answer ?? user_answer,
      isNotEmptyOrNull(displayedQues[currentQuesIndex]?.factual_rule_set) &&
        isNotEmptyOrNull(
          displayedQues[currentQuesIndex]?.factual_rule_set?.[0].questions
        ) &&
        displayedQues[currentQuesIndex]?.factual === true
        ? 1
        : isNotEmptyOrNull(displayedQues[currentQuesIndex]?.contents)
        ? 1
        : answerCount ?? count
    );
    setIsNextQuestionLoading(false);
    setIsAnswerSubmitted(false);
    setOverAllQuestionResult({});
    setShowNextBtnForFactual(false);
    setDisplayQuestionsWithoutFactualVideo(false);
    setIsCorrect(false);
    setQuestionStartTime(new Date());
    if (success && data?.questions?.length > 0) {
      const updatedIndex = curIndex + 1;
      const quesObj = {
        ...data?.questions?.[0],
        dialog_entry_script: data?.dialog_entry_script,
        rules: data?.rules,
        learning_mode: data?.learning_mode,
        visited_question_indices: data?.visited_question_indices,
        ...(data?.user_answer
          ? { userAnswer: JSON.parse(data?.user_answer), showGreen: true }
          : {}),
      };
      let ques = [...displayedQuesRef?.current];
      ques.push(quesObj);

      setDisplayedQues(ques);
      setChatId(generateNewChatId());
      setCurrentQuestionIndex(updatedIndex);
      handleExtraAndStoreImages(quesObj, updatedIndex);
      setLearningStepData(data);
      setTaskStepId(data?.step_id);
      setOverAllQuestionResult();
      let newHistory = { ...chatHistoryRef.current };
      newHistory[updatedIndex] = [];
      setChatHistory(newHistory);
    } else if (data?.step_id == 0) {
      const updatedIndex = curIndex + 1;
      setCurrentQuestionIndex(updatedIndex);
      let ques = [...displayedQuesRef?.current];
      setDisplayedQues(ques);
      setLearningStepData(data);
      setTaskStepId(data?.step_id);
      // setCurrentQuestionIndex(updatedIndex);
      setOverAllQuestionResult();
      setIsLastQues(true);
    } else if (
      data?.learning_mode?.toLowerCase() === learningModes.FactualBasket
    ) {
      const updatedIndex = curIndex + 1;
      let ques = [...displayedQuesRef?.current];
      ques.push(data);

      setDisplayedQues(ques);
      setLearningStepData(data);

      if (isNotEmptyOrNull(data?.contents)) {
        setShowNextBtnForFactual(true);
      } else if (isNotEmptyOrNull(data?.factual_rule_set?.[0]?.questions)) {
        setDisplayQuestionsWithoutFactualVideo(true);
      }
      setTaskStepId(data?.step_id);

      setCurrentQuestionIndex(updatedIndex);
    } else if (!success) {
      sendCustomEvent(
        "Failed to start execute journey",
        "error",
        {
          journeyid: journeyId,
          stepid: step_id,
        },
        ["failed__executejourney", journeyId]
      );
    } else if (success && isNotEmptyOrNull(data.error)) {
      sendCustomEvent(
        "Internal data failed",
        "error",
        {
          journeyid: journeyId,
          stepid: step_id,
          response: data.error,
        },
        ["failed__internal", journeyId, new Date().toISOString()]
      );
    }
    console.log("DisplayedQuestion", displayedQuesRef.current);
  };

  const fetchMediaDetails = async (questionID) => {
    try {
      setMediaDetails([]);
      let { data = [] } = await getGpMedia(questionID);
      data = data?.filter((item) => !isEmptyOrNull(item?.transcript));
      setMediaDetails(data);
    } catch (e) {
      console.log(e);
    }
  };

  const handleUpdateisConv = async () => {
    let index = currentQuesIndexRef?.current;
    let existing = [...displayedQuesRef?.current];
    if (isNotEmptyOrNull(existing[index])) {
      existing[index].showGreen = true;
    }
    setDisplayedQues(existing);
    if (assesmentInfo?.journeyId) {
      const { journeyId, questionId, userAnswer } = assesmentInfo || {};
      await updateChatIdInLpProgress(
        journeyId,
        questionId,
        JSON.stringify(userAnswer)
      );
    }
  };
  const handleFetchQuestions = async () => {
    generateGuidedPrtcice();
  };
  const prepareChatInput = (query) => {
    let updateHistory =
      chatHistoryRef?.current?.[currentQuesIndexRef?.current] || [];
    updateHistory = updateHistory?.map((item) => {
      let existing = { ...item };
      delete existing?.chatID;
      return { ...existing };
    });

    let inputParams = {
      query: query,
      chat_history: updateHistory || [],
      response_status: isCorrectRef?.current ? "correct" : "wrong",
    };
    if (isPlayground) {
      inputParams["playground_status"] = 1;
    }
    return { ...inputParams, ...getCurriculumInfo() };
  };
  const handleStreaming = (chunk) => {
    setStreamingText((prev) => {
      let updatedText = prev + chunk;
      if (updatedText?.includes("#*#*#")) {
        setIsConvCompleted(true);
      }
      return updatedText;
    });
  };
  const handlePracticeConv = async (
    query,
    isConclude,
    isRetry,
    hashedQuery
  ) => {
    setShowHintBtn(false);
    setIsApiLoading(true); // Start API loading
    if (!isConclude) {
      setChatQuery(query);
    }
    setUserQuery("");
    let ans = [];
    if (!Array.isArray(query)) {
      ans = [hashedQuery];
    }
    if (
      isNotEmptyOrNull(
        displayedQuesRef.current?.[currentQuesIndexRef.current]?.userAnswer
          ?.chatId
      ) &&
      !isDiscussFlow
    ) {
      setChatIndex(
        (chatHistoryRef.current?.[currentQuesIndexRef.current]?.length || 0) / 2
      );
    }
    if (chatIndexRef?.current === 0) {
      let result = matchFibAnswers(
        isNotEmptyOrNull(
          displayedQuesRef?.current?.[currentQuesIndexRef?.current]
            ?.answers_index_hashed_keys
        )
          ? displayedQuesRef?.current?.[currentQuesIndexRef?.current]
              ?.answers_index_hashed_keys
          : isNotEmptyOrNull(
              displayedQuesRef?.current?.[currentQuesIndexRef?.current]
                ?.answers_key
            )
          ? displayedQuesRef?.current?.[currentQuesIndexRef?.current]
              ?.answers_key
          : displayedQuesRef?.current?.[currentQuesIndexRef?.current]
              ?.answers_layout,
        ans,
        0,
        isNotEmptyOrNull(
          displayedQuesRef?.current?.[currentQuesIndexRef?.current]?.answers_key
        ),
        displayedQuesRef?.current?.[currentQuesIndex]?.options_layout,
        isNotEmptyOrNull(
          displayedQuesRef?.current?.[currentQuesIndexRef?.current]
            ?.answers_index_hashed_keys
        )
      );
      setIsCorrect(result?.overAllResult || false);
    }
    const body = prepareChatInput(query);
    delete body.shortcut_fill;
    if (query == BOTTOM_BUTTONS.hint) {
      body.shortcut_fill = 1;
    }
    delete body.is_concluded;
    if (isConclude) {
      body.is_concluded = true;
    }
    body.version_uuid =
      displayedQuesRef?.current?.[currentQuesIndexRef?.current]?.version_uuid;

    if (isRetry) {
      body.retry_status = true;
      body.retry_index = tryCountRef?.current;
    }
    body.taskType = getTaskType(taskType);
    let inputBody = {
      data: body,
    };
    setLoader(true);
    const { success = false, status = "" } = await practiceConvo(
      handleStreaming,
      setIsCompleted,
      setLoader,
      inputBody,
      chatIdRef?.current,
      chatIndexRef?.current,
      setLoaderText
    );
    setIsApiLoading(false); // End API loading
    setIsConcludeInProgress(false);
    console.log(success, status);
    if (!success) {
      if (status == HTTP_CODES.BAD_REQUEST) {
        setTryCount(0);
        setIsConvCompleted(true);
        showToast({
          description: ERROR_MESAGES.BAD_REQUEST,
          status: "error",
          duration: 3000,
        });
      } else {
        setStreamingText("");
        handleRetryFlows(query, isConclude);
      }
    } else {
      setTryCount(0);
    }
  };
  const handleRetryFlows = (query, isConclude) => {
    if (tryCountRef?.current <= 1) {
      setTryCount((prev) => prev + 1);
      if (isEmptyOrNull(loaderText)) {
        setLoaderText(LOADING_MESSAGE);
        setIsCompleted(false);
        setLoader(true);
      }
      setTimeout(() => {
        handlePracticeConv(query, isConclude, true);
      }, 2000);
    } else {
      setTryCount(0);
      setLoaderText("");
      setIsConvCompleted(true);
      showToast({
        description: ERROR_MESAGES.SERVER_ERROR,
        status: "error",
        duration: 3000,
      });
    }
  };
  const prepareConvseScoreInput = (index) => {
    const { question, options, hintandexplanations, answers_layout } =
      displayedQuesRef?.current[index] || {};
    let explaination = hintandexplanations?.[0]?.explanation?.[0]?.data;
    explaination = explaination?.map((item) => item?.text);
    explaination = explaination?.join(",");

    let question_assit = question + "\n" + "Options:\n ";
    const modifiedOptions = options?.map(
      (item, index) => `${index + 1} . ${item}`
    );
    question_assit += modifiedOptions?.join("\n ");
    let history = chatHistoryRef?.current?.[index] || [];
    let obj = {
      chat_history: history,
      question: question_assit,
      explaination: explaination,
      correct_answer: answers_layout?.join(",") || "",
    };
    return { ...obj, ...curriculumObj };
  };
  const handleConverseScore = async () => {
    let index = currentQuesIndexRef?.current;
    let body = prepareConvseScoreInput(index);
    let response = await getConvrseScore(
      body,
      chatIdRef?.current,
      chatIndexRef?.current
    );
    // console.log("converse score---" + response);
  };
  const handleHintClick = () => {
    handlePracticeConv(BOTTOM_BUTTONS.hint);
  };
  const resetPractice = (selfLearnButtonClick = false, isSideNav = false) => {
    if (window?.ENV?.ENABLE_VOICE == "true") {
      handleResetAudio();
    }
    setDescriptiveAnswer({});
    setIsConcluded(false);
    setQuestionID("");
    setIsAnswerSubmitted(false);
    setShowHintBtn(false);
    if (!selfLearnButtonClick && !isSideNav) {
      setSelectedSubTopic("");
      setSelectedTopic("");
      setSubjectName("");
      setTopicName("");
      setSubTopicName("");
      setSubject("");
      setTopic("");
    }
    setDisplayedQues([]);
    setGrade("");
    setLearningStepData({});
    setJourneyId(""); // not making it empty bacause journey id is required in success screen for Review
    setClassifierInfo(classifierInitialState);
    setAssistantRefImages({});
    setCurrentQuestionIndex(-1);
    setQuestions([]);
    setChatHistory([]);
    setChatQuery("");
    setIsLastQues(false);
    setOverAllQuestionResult();
    setSelectedJourney();
    setChatIndex(0);
    setIsFeedbackSubmitted(false);
    setIsTaskCompleted(false);
    setMediaDetails([]);
    setSelectedFactualIndex();
  };
  const handleNextQuestion = (resultObject, answerValue) => {
    if (window?.ENV?.ENABLE_VOICE == "true") {
      handleResetAudio();
    }
    setMediaDetails([]);
    setChatIndex(0);
    setIsConcluded(false);
    setIsFeedbackSubmitted(false);
    setShowHintBtn(false);
    // setIsAnswerSubmitted(false);
    setIsConvCompleted(false);

    if (isLastQuesRef?.current) {
      setIsAnswerSubmitted(false);
      if (isStandaloneWithSubjectMapping || isStandalone) {
        setTaskStatus(
          "Looks like " +
            (subTopicName ? subTopicName : topicName) +
            " clicked!  Ready for the next challenge?"
        );
        setIsTaskCompleted(true);
      } else {
        callFinishStep();
      }
    } else {
      handleUpdateisConv();
      if (!isDescAnsQues) {
        handleConverseScore();
      }
      fetchPracticeQuestions(
        journeyId,
        taskStepId,
        resultObject,
        answerValue,
        showNextBtnForFactual
      );
    }
  };
  const handleTryAnotherQues = () => {
    setIsConvCompleted(false);
    setMediaDetails([]);
    resetPractice();
  };
  const handleBackToPreview = async () => {
    const { journeyId } = assesmentInfo || {};
    setAssesmentInfo({});
    setClearAllBottomButtons(true);
    setSelectedJourney(journeyId);
    // navigate(-1);
    navigate(`${urlString}/review`, {
      state: {
        journeyId: journeyId,
      },
    });
  };
  const handleConclude = () => {
    setIsConcluded(true);
    // 'true' indicates the conclusion of the practice conversation
    setIsConcludeInProgress(true);
    handlePracticeConv(BOTTOM_BUTTONS.conclude, true);
  };
  const isEnableSubmitBtn =
    userQuery?.trim()?.length > 0 &&
    streamingTextRef?.current?.length == 0 &&
    loader == false;
  const chatHistoryAtIndex =
    chatHistoryRef?.current?.[currentQuesIndexRef?.current];
  let assistantMessages = [];

  if (Array.isArray(chatHistoryAtIndex)) {
    assistantMessages = chatHistoryAtIndex.filter(
      (message) => message?.role === "assistant"
    );
  }

  let assistantMessageLength = assistantMessages?.length;
  let allowToEnter =
    !isConvCompleted &&
    streamingTextRef?.current?.length == 0 &&
    loader == false;
  const showFeedbackBtn =
    isStandalone &&
    !isLastQuesRef?.current &&
    isConvCompletedRef?.current &&
    isEmptyOrNull(assesmentInfo?.journeyId);
  const buttons = {
    isEnableSubmitBtn,
    showNextBtn:
      isConvCompletedRef.current &&
      !isApiLoading &&
      isEmptyOrNull(questionID) &&
      isEmptyOrNull(assesmentInfo?.journeyId),
    showConcludeBtn: showConcludeBtnRef?.current,
    allowToEnter,
    showFeedBack: showFeedbackBtn,
    showNextBtnForFactual: showNextBtnForFactualRef?.current,
    setShowNextBtnForFactual,
    isLastQues: isLastQuesRef?.current,
    assistantMessageLength,
    showHintBtn: showHintBtnRef?.current,
    showTryAnotherQuesBtn:
      isConvCompletedRef?.current && !isEmptyOrNull(questionID),
    handleTryAnotherQues,
    clearAllBottomButtons: clearAllBottomButtonsRef?.current,
    handleHintClick: handleHintClick,
    handleConclude: handleConclude,
    setChatHistory: setChatHistory,
    setDisplayedQues: setDisplayedQues,
    setCurrentQuestionIndex: setCurrentQuestionIndex,
    setQuestions: setQuestions,
    setChatQuery: setChatQuery,
    showBackToPreview:
      !isEmptyOrNull(assesmentInfo?.journeyId) && isConvCompleted,
    handleBackToPreview: handleBackToPreview,
    isDescAnsQues,
    chatId: chatIdRef?.current,
  };
  const state = {
    handleFetchQuestions,
    handlePracticeConv,
    handleNextQuestion,
    setQuestions,
    questions: questionsRef?.current,
    setDisplayedQues,
    displayedQues: displayedQuesRef?.current,
    currentQuesIndex: currentQuesIndexRef?.current,
    setCurrentQuestionIndex,
    setChatId,
    chatQuery: chatQueryRef?.current,
    streamingText: streamingTextRef?.current,
    setStreamingText,
    setIsCompleted,
    chatHistory: chatHistoryRef?.current,
    buttons,
    isConvCompleted: isConvCompletedRef?.current,
    setIsConvCompleted,
    setIsCorrect,
    chatId: chatIdRef?.current,
    setChatQuery,
    setChatHistory,
    setLearningStepData,
    learningStepData: learningStepDataRef?.current,
    isLastQues: isLastQuesRef?.current,
    setSelectedJourney,
    selectedJourney: selectedJourneyRef?.current,
    setShowHintBtn,
    resetPractice,
    setClearAllBottomButtons,
    setChatIndex,
    mediaDetails: mediaDetailsRef?.current,
    isAnswerSubmitted: isAnswerSubmittedRef?.current,
    setIsAnswerSubmitted,
    setMediaDetails,
    setShowNextBtnForFactual,
    setDisplayQuestionsWithoutFactualVideo,
    displayQuestionsWithoutFactualVideo:
      displayQuestionsWithoutFactualVideoRef?.current,
    assistantRefImages,
    handleExtraAndStoreImages,
    questionID,
    setQuestionID,
    isDescAnsQues,
    handleLongAnsStreamFlow,
    descriptiveAnswer,
    isConcluded,
    taskCategory,
    setTaskCategory,
    setQuestionStartTime,
    questionStartTime: questionStartTimeRef?.current,
    setQuestionEndTime,
    questionEndTime: questionEndTimeRef?.current,
    setShowConcludeBtn,
    updateShowConcludeBtn,
    isDescSubmitted: isDescSubmittedRef?.current,
    setIsNextQuestionLoading,
    isNextQuestionLoading: isNextQuestionLoadingRef?.current,
  };
  return (
    <PracticeContext.Provider value={state}>
      {children}
    </PracticeContext.Provider>
  );
};

export const usePractice = () => {
  return useContext(PracticeContext);
};
